import './index.scss'
export { Checkbox, Checkbox as default } from 'carbon-components-react'
